import React from "react"
import MetaButton from "@components/MetaButton"
import SVGHeader from "@components/SVGHeader"
import Markdown from "@components/Markdown"
import ImageHome from "@components/MockableImages"

import { useTranslation } from "gatsby-plugin-react-i18next"
export default ({
  backgroundImage = "https://picsum.photos/1920/1080",
  backgroundImageGradient = true,
  video = false,
  motto,
  cta1text,
  cta2text,
  cta1action,
  cta2action,
  largeText,
  theme = "blue-bg",
  mottoOnTop = false,
  smExtraClassName,
  useButton1Navigate,
  useButton2Navigate,
  button1LinkTag,
  button2LinkTag,
  dataEvent1,
  dataEvent2,
  button1Url,
  button2Url,
  bgClasses = "",
  largeTextClasses = "",
}) => {
  let background = "",
    color = ""

  switch (theme) {
    case "blue-bg":
      background = "bg-dblue"
      color = "text-white"
      break
    case "white-bg":
      background = "bg-white"
      color = video ? "text-white" : "text-dblue"
      break
    case "gray-bg":
      background = "bg-lblue"
      color = "text-dblue"
      break
  }

  let bg = `bg-cover bg-center aspect-square md:h-screen md:aspect-auto ${bgClasses}`
  if (mottoOnTop) bg = "bg-contain bg-bottom aspect-video"
  const { t, i18n } = useTranslation()

  return (
    <div className={`${background} ${!video ? "px-6 md:px-12" : ""}`}>
      {motto != undefined && mottoOnTop ? (
        <div
          className={`${color} text-3xl xl:text-5xl fhd:text-7xl hidden md:block pl-12 pt-24  fhd:max-w-screen-fhd fhd:mx-auto`}
        >
          <div className="max-w-[50%]">
            <Markdown>{motto}</Markdown>
          </div>
        </div>
      ) : null}
      <div
        className={`w-full bg-white ${bg} bg-no-repeat bg-center flex flex-col justify-between max-w-screen-fhd mx-auto relative`}
      >
        {video ? (
          <>
            <div className="w-full h-full absolute  ">
              <ImageHome image={backgroundImage} />
            </div>
          </>
        ) : (
          <ImageHome image={backgroundImage} />
        )}
        <div className="pt-24 pl-24 z-10">
          {motto != undefined && !mottoOnTop ? (
            <div
              className={`${color} text-3xl xl:text-5xl fhd:text-7xl max-w-[50%] hidden md:block`}
            >
              <Markdown>{motto}</Markdown>
            </div>
          ) : null}
          <div className="cta md:flex flex-row gap-5 mt-7 hidden z-10">
            <div className="flex-grow-0">
              {cta1text != undefined ? (
                <MetaButton
                  inverted
                  theme="blue-bg"
                  onClick={cta1action}
                  dataEventId="StartProForm"
                  useNavigate={useButton1Navigate}
                  as={button1LinkTag}
                  dataEvent={dataEvent1}
                  url={button1Url}
                >
                  {cta1text}
                </MetaButton>
              ) : null}
            </div>
            <div className="flex-grow-0">
              {cta2text != undefined ? (
                <MetaButton
                  inverted
                  theme="blue-bg"
                  onClick={cta2action}
                  dataEventId="BookAppointment"
                  useNavigate={useButton2Navigate}
                  as={button2LinkTag}
                  dataEvent={dataEvent2}
                  url={button2Url}
                >
                  {cta2text}
                </MetaButton>
              ) : null}
            </div>
          </div>
        </div>

        <div className={`${largeTextClasses} px-6 desk:px-12 z-10`}>
          <SVGHeader text={largeText} />
        </div>
      </div>
      <div
        className={`md:hidden md:h-0 ${color} text-3xl py-6 ${smExtraClassName}`}
      >
        <Markdown>{motto}</Markdown>
      </div>
    </div>
  )
}
